/**
* 2020.05.25
* */

import * as THREE from '../../libs/three/three.module'
import { ColladaLoader } from '../../libs/jsm/loaders/ColladaLoader'
import threeFun from '../../common/createThree'
export default {
  mixer: undefined,
  SOURCE_URL: 'assets/three/iloveu/',
  textGroup: new THREE.Group(),
  BEVEL_ENABLED: true,
  ROTATE_SPEED: 0.01,

  // Main function, program entrance
  init () {
    threeFun.init().then(() => {
      this.initSceneConfig() // Config scene
      this.addModel()
      this.addText()
      this.addControl()
    })
  },
  initSceneConfig(){
    threeFun.camera.position.set( 15, 10, - 15 )
    threeFun.scene.background = new THREE.Color(0x000000)
  },

  addModel(){
    this.addSolder()

    let gridHelper = new THREE.GridHelper( 10, 20 )
    threeFun.scene.add( gridHelper )

    let ambientLight = new THREE.AmbientLight( 0xffffff, 0.2 )
    threeFun.scene.add( ambientLight )

    let pointLight = new THREE.PointLight( 0xffffff, 0.8 )
    threeFun.scene.add( threeFun.camera )
    threeFun.camera.add( pointLight )

    threeFun.scene.remove(threeFun.light)
  },
  addSolder(){
    let loader = new ColladaLoader()
    let url = this.SOURCE_URL + 'models/stormtrooper/stormtrooper.dae'
    let onload = collada => {

      if(!collada) return

      let animations = collada.animations
      let avatar = collada.scene

      avatar.traverse( function ( node ) {

        if ( node.isSkinnedMesh ) {

          node.frustumCulled = false

        }

      } )

      this.mixer = new THREE.AnimationMixer( avatar )
      this.mixer.clipAction( animations[ 0 ] ).play()

      threeFun.scene.add( avatar )

      this.loopFunc()

    }
    let onError = e => {console.log('模型加载出错: ', e)}
    loader.load( url, onload, undefined, onError )
  },
  addText(){
    let loader = new THREE.FontLoader();

    loader.load( this.SOURCE_URL + '/fonts/FZTanHeiS-B-GB_Regular.json',  font => {

      let param = {
        font: font,
        size: 1,
        height: 0.5,
        curveSegments: 1,
        bevelEnabled: false,
        bevelThickness: 1,
        bevelSize: 1,
        bevelSegments: 1
      };
      let ivu = "我爱兔兔黄思敏";
      let radius = 5;
      let rad = -Math.PI * 2 / 7;
      let pos = {x:0, z:0};
      for(let i in ivu){

        rad += Math.PI * 2 / 7;
        pos.x = radius * Math.cos(rad);
        pos.z = radius * Math.sin(rad);

        let geometry = new THREE.TextGeometry( ivu.charAt(i), param );
        let text = this.createMesh(geometry, param);
        text.position.x -= param.size / 2;
        text.scale.set(1, 1, 1);
        text.rotation.y = - rad + Math.PI / 2;
        text.position.set(pos.x, 0, pos.z);
        this.textGroup.add(text);
      }

      threeFun.scene.add(this.textGroup);

      // 根据角度计算圆的坐标点
      // x = centerX + radius * cos(rad);
      // y = centerY + radius * sin(rad);
      // rad = angle * Math.PI / 180;
      // centerX centerY 圆的中心点

    } );
  },
  createMesh(geom, param) {

    let {bevelEnabled, height, size} = param

    let materials = [
      new THREE.MeshLambertMaterial( { color: 0xff5555, flatShading: true } ), // front
      new THREE.MeshLambertMaterial( { color: 0xffffff } )                     // side
    ]

    geom.computeBoundingBox()
    geom.computeVertexNormals()

    let triangle = new THREE.Triangle()

    // "fix" side normals by removing z-component of normals for side faces
    // (this doesn't work well for beveled geometry as then we lose nice curvature around z-axis)

    if ( ! bevelEnabled ) {

      let triangleAreaHeuristics = 0.1 * ( height * size )

      for ( let i = 0; i < geom.faces.length; i ++ ) {

        let face = geom.faces[ i ]

        if ( face.materialIndex === 1 ) {

          for ( let j = 0; j < face.vertexNormals.length; j ++ ) {

            face.vertexNormals[ j ].z = 0
            face.vertexNormals[ j ].normalize()

          }

          let va = geom.vertices[ face.a ]
          let vb = geom.vertices[ face.b ]
          let vc = geom.vertices[ face.c ]

          let s = triangle.set( va, vb, vc ).getArea()

          if ( s > triangleAreaHeuristics ) {

            for ( let j = 0; j < face.vertexNormals.length; j ++ ) {

              face.vertexNormals[ j ].copy( face.normal )

            }

          }

        }

      }

    }
    let textGeo = new THREE.BufferGeometry().fromGeometry( geom )

    return new THREE.Mesh( textGeo, materials )

  },

  addControl(){
    threeFun.createOrbitControl()
  },
  loopFunc(){
    threeFun.loopFunc.push(delta => {
      this.mixer.update(delta)
      this.textGroup.rotation.y += this.ROTATE_SPEED
    })
  },
}
